import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Grid } from '@chakra-ui/react'

import DefaultLayout from '../../../../layouts/DefaultLayout'

import { MdQuestionAnswer } from 'react-icons/md'

// Services
import { languageServices } from '../../../../services/common/languages'

// Components
import GeneralCard from '../../../../components/cards/generalCard/GeneralCard'
import LoadingComponent from '../../../../components/shareds/LoadingComponent'
import DetailCard from '../../../../components/cards/detailCard/DetailCard'
import NavCard from '../../../../components/cards/navCard/NavigateCard'
import UpdateDeleteButton from '../../../../components/customFormElements/UpdateDeleteButton'

const LanguageDetail = () => {
  const [languageData, setLanguageData] = useState<any | null>(null)
  const navigate = useNavigate()

  const id = location.pathname.split('/language/')[1]

  useEffect(() => {
    languageServices.findOne(id).then((response) => {
      setLanguageData(response.data)
    })
  }, [])

  const deleteFunction = (id: string) => {
    languageServices.remove(id).finally(() => {
      navigate('/language')
    })
  }

  if (!languageData) {
    return <LoadingComponent />
  }

  return (
    <DefaultLayout>
      <NavCard icon={MdQuestionAnswer} pageName='Language' />
      <GeneralCard title='Language Detail'>
        <Grid templateRows='repeat(3, 1fr)' templateColumns='repeat(4, 1fr)' gap={4} margin={'20px'}>
          <DetailCard upperText='Name' lowerText={languageData.name} />
          <DetailCard upperText='Code' lowerText={languageData.code} />
          <DetailCard upperText='Flag' lowerText={languageData.flag} />
          <DetailCard upperText='Order Number' lowerText={languageData.orderNumber} />
          <DetailCard upperText='RTL' lowerText={languageData.rtl.toString()} />
        </Grid>
      </GeneralCard>
      <UpdateDeleteButton deleteFunction={deleteFunction} id={id} navigateUrl={'/language/update'} />
    </DefaultLayout>
  )
}

export default LanguageDetail
